export default __webpack_public_path__ + "static/more-press-top-image-9bd600cb42db872d767b6beeb61956d9.png";